import {
  Menu,
  Trash2,
  EllipsisVertical,
  ChevronDown,
  UserCircle,
  Lock,
  EyeClosed,
  Eye,
  Search,
  ChevronUp,
  PlusCircle,
  AlertCircle,
  X,
  Plus,
  Sparkles,
  Unlock,
  LogOut,
  LineChart,
  PieChart,
  BarChart3,
  Briefcase,
  Bell,
  Volume2,
  Dot,
  MoonStar,
  Sun,
} from "lucide-react";

export const ICONS = {
  Menu,
  Trash2,
  EllipsisVertical,
  ChevronDown,
  UserCircle,
  Lock,
  EyeClosed,
  Eye,
  ChevronUp,
  Search,
  PlusCircle,
  AlertCircle,
  X,
  Plus,
  Sparkles,
  Unlock,
  LogOut,
  LineChart,
  PieChart,
  BarChart3,
  Briefcase,
  Bell,
  Volume2,
  Dot,
  MoonStar,
  Sun,
};
